import $ from 'jquery';
// import Swiper JS
import Swiper, { Autoplay, Pagination, Navigation } from 'swiper';

Swiper.use([Autoplay, Pagination, Navigation])
window.swipers = [];

const swiperConfig = {
	spaceBetween: 24,
	navigation: {
		nextEl: '.js-swiper-button-next',
		prevEl: '.js-swiper-button-prev',
	},
	breakpoints: {
		'1200': {
			slidesPerView: 4.4,
		},
		'800': {
			slidesPerView: 3.3,
		},
		'400': {
			slidesPerView: 2.2,
		},
		'100': {
			slidesPerView: 1.1,
		},
	},
};

export const initSwiper = function () {
	const $slider = $(this);
	const config = $slider.data('config');
	const usedConfig = { ...swiperConfig, ...config };
	const swiperInstance = new Swiper(this, usedConfig);
	window.swipers.push(swiperInstance);

	const swipeTo = $slider.data('swiper-swipe-to');
	const $activeCompetence = $('[data-is-active]')
	if ($activeCompetence[0]) {
		setTimeout(() => {
			$('.swiper-slide').each(function (index) {
				if (this.contains($activeCompetence[0])) {
					setTimeout(() => {
						swiperInstance.slideTo(index, 0);
					}, 50);
				}
			})
		}, 50)
	} else if (swipeTo) {
		setTimeout(() => {
			swiperInstance.slideTo(swipeTo, 0);
		}, 50);
	}
};

const $sliders = $('.slider');
$sliders.each(initSwiper);

export default swiperConfig;
